export type DynamicConfig = {
  apiUrl: string;
  auth: {
    url: string;
    client_secret: string;
    client_id: string;
    response_type: string;
    scope: string;
  };
  environment: 'DEV' | 'TEST' | 'STAGE' | 'PROD';
};

export const defaultConfig: DynamicConfig = {
  apiUrl: 'https://test-api.viatel.local/BlockEngine',
  environment: 'DEV',
  auth: {
    url: 'https://test-auth.viatel.local',
    client_secret: '3da5aae2-3a90-4930-84a6-db3dcbccaa4a',
    client_id: 'BlockEngineBuilder',
    response_type: 'code',
    scope: 'openid profile roles'
  }
};

export const dynamicConfigUrl = 'config.json';
